module.exports = __webpack_public_path__ + "static/NightInTheWoods1-dc1f0da22131f6409593c170630c6423.webp";